import { render, staticRenderFns } from "./fansBar.vue?vue&type=template&id=06792bff&scoped=true"
import script from "./fansBar.vue?vue&type=script&lang=js"
export * from "./fansBar.vue?vue&type=script&lang=js"
import style0 from "./fansBar.vue?vue&type=style&index=0&id=06792bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06792bff",
  null
  
)

export default component.exports